import React from "react";
import styled from "styled-components";
import GridImg from "images/png/rated-tube-grid.png";

import Typography from "components/typography";
import { Colors } from "utils/colors";
import PrimaryButton from "components/buttons/primary-button";
import FAQs from "../FAQs";
import HeroImg from "images/png/rated-fans-hero.png";
import HowItWorks from "./how it works";

const Default = () => {
  const GetStarted = () => {};
  return (
    <Container>
      <Grid alt="grid" src={GridImg} />
      <Header>
        <Typography
          color={Colors.white100}
          size="4xl"
          weight="bold"
          m_size="xl"
          mr="0.4"
        >
          R<span style={{ color: "#FF0050" }}>A</span>ted
        </Typography>
        <Typography
          color={Colors.white100}
          size="4xl"
          m_size="xl"
          weight="bold"
        >
          Fans
        </Typography>
      </Header>
      <HeroSection>
        <HeroText>
          <Typography
            lh="7.2"
            weight="semibold"
            size="6rem"
            m_size="4xl"
            m_lh="2.4"
          >
            Create Custom Smart & Pre-save links
          </Typography>
          <HeroBodyText>
            <Typography>
              <span> Rated Fans</span> RAted Fans helps artists create
              <span>customizable</span> Smart URLs and Presave links for music
              tracks and videos, boosting engagement and reach by making it easy
              to share content and drive fan interaction across platforms.
            </Typography>
          </HeroBodyText>
          <GetStartedButton>
            <PrimaryButton
              onClick={GetStarted}
              inset
              text="Get Started"
              icon={
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="100%"
                  height="100%"
                  viewBox="0 0 20 20"
                  fill="none"
                >
                  <path
                    d="M3.33301 10H16.6663M16.6663 10L11.6663 5M16.6663 10L11.6663 15"
                    stroke="#131313"
                    stroke-width="1.25"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              }
              iconPosition="right"
              iconSize="2"
            />
          </GetStartedButton>
        </HeroText>
        <HeroImage src={HeroImg} alt="hero" />
      </HeroSection>
      <HowItWorks />

      <FAQs />
    </Container>
  );
};

export default Default;

const Container = styled.div`
  width: 100%;
  padding-top: 3.2rem;
  min-height: 100vh;
  max-height: 100%;
  position: relative;
`;

const Grid = styled.img`
  width: 100%;
  height: 100vh;
  position: absolute;
  right: 0;
  top: 0;
  @media only screen and (max-width: 769px) {
    width: 150rem;
    height: 100rem;
  }
`;

const Header = styled.div`
  display: inline-flex;
`;

const HeroSection = styled.div`
  margin-top: 3.2rem;
  display: flex;
  position: relative;
  margin-bottom: 30rem;
  @media only screen and (max-width: 769px) {
    flex-direction: column;
    margin-bottom: 2rem;
    margin-top: 1.9rem;
  }
`;

const HeroImage = styled.img`
  position: absolute;
  width: 60%;
  object-fit: cover;
  right: 5%;
  top: -45%;

  @media only screen and (max-width: 769px) {
    position: relative;
    width: 100%;
    top: 0;
    right: 10%;
  }
`;

const HeroText = styled.div`
  width: 48%;
  z-index: 2;
  position: relative;
  @media only screen and (max-width: 769px) {
    width: 100%;
  }
`;
const HeroBodyText = styled.div`
  display: inline-flex;
  color: #909090;
  margin-top: 1.5rem;

  p {
    font-size: 2rem;

    span {
      color: white;
      font-weight: 500;
    }

    @media only screen and (max-width: 769px) {
      font-size: 1.4rem;
    }
  }
`;

const GetStartedButton = styled.div`
  width: fit-content;
  margin-top: 4.3rem;
  @media only screen and (max-width: 769px) {
    margin-top: 2.4rem;
  }
`;
